import React from "react"
import { Link } from "react-router-dom"

const SectionOne = () => {
  return (
    <div className="mt-24 pb-20 py-20 mobiles:text-center global-container">
      <div className="flex mobiles:flex-col items-center">
        <div className="w-1/2 mobiles:w-full mobiles:order-2">
          <h2 className="font-60px mobiles:hidden  sabi-header leading-tight">
            We<span className="header-bg-design sabi-header">dding</span> &
            Events <br /> registry made easy
          </h2>
          <h2 className="mobiles:block hidden mobiles:text-4xl sabi-header leading-loose">
            We<span className="header-bg-design sabi-header">dding</span> &
            Events registry made easy
          </h2>
          <p className="mt-4 mobiles:mt-8 text-xl mobiles:text-base">
            Easiest way to manage your gift registry.
          </p>
          <div className="mt-8 mobiles:mt-12 flex mobiles:justify-center">
            <Link
              to="/get-started"
              className=" py-2.5 px-11 mobiles:px-3 bg-sbg-light-green border border-transparent text-transparent rounded-md text-base text-white "
            >
              Get Started
            </Link>

            <Link
              to="/find-registry"
              className=" py-2.5 mobiles:px-3 px-11 ml-4 border border-gray-100 text-sbg-pink text-transparent rounded-md text-base"
            >
              Find an event
            </Link>
          </div>
        </div>
        <div className="w-1/2 mobiles:w-full mobiles:order-1 mobiles:mb-10">
          <img
            src={require("../../assets/hero-image-sd.svg").default}
            alt="hero"
            className="w-90% mobiles:w-full mx-auto"
          />
        </div>
      </div>
    </div>
  )
}

export default SectionOne
